import { styled } from '@mui/material/styles';

export const Text = styled('p')`
  font-size: 0.8125rem;
  line-height: 1;
  margin: 0;
`;
